/** Volleyball match officiating — minimum hiring charges (KES). Keep in sync with backend match.py */
export const FIRST_OFFICIAL_MIN_HIRE_KES = 2000;
export const ADDITIONAL_OFFICIAL_MIN_HIRE_KES = 1000;
export const VOLLEYBALL_MAX_OFFICIATING_SLOTS = 5;

export const OFFICIATING_COUNT_OPTIONS = [
  {
    count: 1,
    label: "1 Official",
    summary: "First referee only — common for beach",
    icon: "fa-solid fa-user-shield",
  },
  {
    count: 2,
    label: "2 Officials",
    summary: "First + second referee",
    icon: "fa-solid fa-people-arrows",
  },
  {
    count: 3,
    label: "3 Officials",
    summary: "Two refs + line judge",
    icon: "fa-solid fa-flag",
  },
  {
    count: 4,
    label: "4 Officials",
    summary: "Refs, line judge + scorer",
    icon: "fa-solid fa-clipboard-list",
  },
  {
    count: 5,
    label: "5 Officials",
    summary: "Full crew incl. libero tracker",
    icon: "fa-solid fa-tablet-screen-button",
  },
];

export const OFFICIATING_SLOTS = [
  {
    slot: 1,
    label: "First Referee",
    role: "Primary match referee (R1)",
    icon: "fa-solid fa-user-shield",
  },
  {
    slot: 2,
    label: "Second Referee",
    role: "Secondary match referee (R2)",
    icon: "fa-solid fa-people-arrows",
  },
  {
    slot: 3,
    label: "Line Judge",
    role: "Sideline / antenna judge",
    icon: "fa-solid fa-flag",
  },
  {
    slot: 4,
    label: "Scorer",
    role: "Score table & set tracking",
    icon: "fa-solid fa-clipboard-list",
  },
  {
    slot: 5,
    label: "Libero Tracker",
    role: "Libero rotation tracking",
    icon: "fa-solid fa-tablet-screen-button",
  },
];

const FORMAT_MAX_OFFICIALS = {
  beach: 2,
  "5v5": 3,
  "6v6": 5,
};

export function officiatingSlotMinimumKes(slotNumber) {
  if (slotNumber <= 0) return 0;
  if (slotNumber === 1) return FIRST_OFFICIAL_MIN_HIRE_KES;
  return ADDITIONAL_OFFICIAL_MIN_HIRE_KES;
}

export function officiatingMinimumCostKes(slotsRequested) {
  if (!slotsRequested || slotsRequested <= 0) return 0;
  const capped = Math.min(Number(slotsRequested), VOLLEYBALL_MAX_OFFICIATING_SLOTS);
  let total = 0;
  for (let slot = 1; slot <= capped; slot += 1) {
    total += officiatingSlotMinimumKes(slot);
  }
  return total;
}

export function formatKes(amount) {
  return `KSh ${Number(amount).toLocaleString("en-KE")}`;
}

export function activeOfficiatingSlots(count) {
  if (!count || count <= 0) return [];
  return OFFICIATING_SLOTS.slice(0, Math.min(count, OFFICIATING_SLOTS.length));
}

export function defaultOfficiatingCountForFormat(matchFormat) {
  if (matchFormat === "beach") return 1;
  if (matchFormat === "5v5") return 2;
  if (matchFormat === "6v6") return 3;
  return 2;
}

export function officiatingCountOptionsForFormat(matchFormat) {
  const max = FORMAT_MAX_OFFICIALS[matchFormat] || VOLLEYBALL_MAX_OFFICIATING_SLOTS;
  return OFFICIATING_COUNT_OPTIONS.filter((opt) => opt.count <= max);
}

export function officiatingFormatHint(matchFormat) {
  if (matchFormat === "beach") {
    return "Beach 2v2 usually needs one referee; two officials for higher-level beach fixtures.";
  }
  if (matchFormat === "5v5") {
    return "5v5 indoor typically uses two referees; add a line judge for better coverage.";
  }
  if (matchFormat === "6v6") {
    return "6v6 standard is three officials (R1, R2, line judge); add scorer and libero tracker for full crew.";
  }
  return "Select your match format above to see recommended officiating options.";
}
